import { MeetingType, SummaryRef } from '../types';

/**
 * Sleutel voor de template-endpoints (/template/{ref}/… en /meeting-types/{ref}).
 * Valt terug op de naam zolang de backend nog geen uuid meestuurt; de backend
 * accepteert beide.
 */
export const getTemplateRef = (template: Pick<MeetingType, 'uuid' | 'name'>): string =>
    template.uuid || template.name;

/** Sleutel voor de verslag-endpoints van een bestaand verslag: template_uuid ?? meeting_type. */
export const getSummaryRef = (summary: SummaryRef): string =>
    summary.templateUuid || summary.meetingType;

/** SummaryRef voor een nieuw verslag met het gekozen template. */
export const summaryRefForTemplate = (template: Pick<MeetingType, 'uuid' | 'name'>): SummaryRef =>
    ({ meetingType: template.name, templateUuid: template.uuid ?? null });

export const templateEditorPath = (templateRef: string): string =>
    `/templates/${encodeURIComponent(templateRef)}`;
